import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import parseCurrency, { currencyConfig } from 'v2/helpers/currency';
import i18next from 'v2/helpers/i18n';
import {
  refineDiffAfterSx,
  refineDiffBeforeSx,
  refineDiffCellSx,
} from './refineStyle';

const CURRENCY_FIELDS = new Set(['budget_rate', 'budget_total']);
const TEXT_FIELDS = new Set(['item_no', 'description', 'tenderee_note']);

const resolveUnitLabel = (value, units) => {
  const unit = (units || []).find(
    (option) =>
      String(option?.value) === String(value) ||
      String(option?.id) === String(value) ||
      String(option?.symbol) === String(value)
  );
  return unit?.label || unit?.symbol || value;
};

export const formatRefineValue = (field, value, units = []) => {
  if (value === null || value === undefined || value === '') {
    return i18next.t('boq-refine-empty-value');
  }
  if (CURRENCY_FIELDS.has(field)) {
    return parseCurrency(value, currencyConfig[i18next.t('currency')]);
  }
  if (field === 'quantity') {
    const number = Number(value);
    return Number.isFinite(number) ? number.toFixed(2) : String(value);
  }
  if (field === 'unit_id' || field === 'unit') {
    return resolveUnitLabel(value, units);
  }
  return String(value);
};

const BoqRefineDiffCell = ({ field, before, after, units = [] }) => {
  const alignItems = TEXT_FIELDS.has(field) ? 'flex-start' : 'flex-end';
  const textAlign = TEXT_FIELDS.has(field) ? 'left' : 'right';

  return (
    <Box
      data-testid={`boq-refine-diff-${field}`}
      sx={{ ...refineDiffCellSx, alignItems, textAlign }}
    >
      <Typography component="span" sx={refineDiffBeforeSx}>
        {formatRefineValue(field, before, units)}
      </Typography>
      <Typography
        component="span"
        sx={{ ...refineDiffAfterSx, whiteSpace: 'pre-wrap' }}
      >
        {formatRefineValue(field, after, units)}
      </Typography>
    </Box>
  );
};

export default BoqRefineDiffCell;
